/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * 
 */

'use strict';

/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(e) {
  this._internalDrag = false;
  this.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;


/*****************
 ** WEBPACK FOOTER
 ** ./~/draft-js/lib/editOnDragOver.js
 ** module id = 462
 ** module chunks = 0 2
 **/